var _defs, _rect, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shieldGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#60a5fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1d4ed8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 184,
    height: 184,
    rx: 42,
    fill: "url(#shieldGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#f8fafc",
    strokeWidth: 4,
    strokeOpacity: 0.95
  }, /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 48,
    x2: 70,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 100,
    x2: 70,
    y2: 152
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 100,
    x2: 150,
    y2: 46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 100,
    x2: 150,
    y2: 154
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f8fafc"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 48,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 100,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 152,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 46,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 154,
    r: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.0deb9578ed8ab6f456eea38f5c669f5a.svg";
export { ForwardRef as ReactComponent };